var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { ChromedashAllFeaturesPage } from './chromedash-all-features-page';
import { customElement } from 'lit/decorators.js';
let ChromedashEnterprisePage = class ChromedashEnterprisePage extends ChromedashAllFeaturesPage {
    renderBox(query) {
        return html `
      <chromedash-feature-table
        query=${query}
        ?signedIn=${Boolean(this.user)}
        ?canEdit=${this.user && this.user.can_edit_all}
        .starredFeatures=${this.starredFeatures}
        @star-toggle-event=${this.handleStarToggle}
        num="100"
        alwaysOfferPagination
        columns="normal"
      >
      </chromedash-feature-table>
    `;
    }
    renderEnterpriseFeatures() {
        return this.renderBox('feature_type="New Feature or removal affecting enterprises" ' +
            'OR enterprise_impact>1');
    }
    render() {
        return html `
      <h2>Enterprise features and breaking changes</h2>
      ${this.renderEnterpriseFeatures()}
    `;
    }
};
ChromedashEnterprisePage = __decorate([
    customElement('chromedash-enterprise-page')
], ChromedashEnterprisePage);
export { ChromedashEnterprisePage };
